<template lang="pug">
div.breadcrumb-section(aria-label="Breadcrumb")
    ul.menu
        li.item(v-for="(ancestor, index) in ancestors" :class="{'with-icon': index != 0}")
            svg(v-if="index != 0" fill='currentColor' viewbox='0 0 20 20' xmlns='http://www.w3.org/2000/svg')
                path(fill-rule='evenodd' d='M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z' clip-rule='evenodd')
            | {{ ancestor }}
</template>

<script>
export default {
    props: {
        ancestors: {
            type: Array,
            default: () => [],
        },
    },
};
</script>


<style lang="scss" scoped>
.breadcrumb-section {
    display: flex;
    margin-top: 10px;
    .menu {
        display: inline-flex;
        align-items: center;
        flex-direction: row;
        margin: 0;
        padding: 0;
        color: rgb(118, 118, 118);

        .item {
            display: inline-flex;
            align-items: center;
            &.with-icon {
                margin-left: 0.2rem;
            }
        }
    }
}

svg {
    height: 20px;
    width: 20px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/tag/components/breadcrumb.vue